import React from 'react';
// Import your regular homepage components that work for business too
import { Header, Footer, DynamicSavings } from '../components/HomePage';
// Import the new BusinessHero component
import BusinessHero from '../components/Segmentations/Business_Persona/BusinessHero';


function BusinessPage() {
  return (
    <>
      
      <BusinessHero />
      {/* You can add business-specific sections here later, or reuse existing ones */}
      
      <Footer />
    </>
  );
}

export default BusinessPage;